<template>
  <div style="margin: 0 24px 12px;">
    <el-form ref="formRef" label-width="auto" label-position="right">
      <el-form-item label="商品名称：">
        {{stockForm.commodityName}}
      </el-form-item>
      <el-form-item label="报损数量：">
        <el-input v-model="breakageNum" placeholder="请输入数量" />
      </el-form-item>
      <el-form-item label="报损原因：">
        <el-input type="textarea" :rows="4" v-model="stockForm.breakageRemark" placeholder="请输入报损原因" style="width: 100%; flex: 1"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 16px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {updateCommodityBreakage} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      type: this.value.type,
      stockForm: this.value.stockForm,

      breakageNum: this.value.stockForm.breakageNum?this.value.stockForm.breakageNum:'',
      breakageRemark: '',

    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.breakageNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入数量',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.stockForm.id
      param['breakageNum'] = this.breakageNum
      param['breakageRemark'] = this.stockForm.breakageRemark
      postFormData(updateCommodityBreakage, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
